import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen } from '@fortawesome/free-solid-svg-icons';

export const ViewTeachingOrderTitleSection = ({ lesson, lessons }) => {
  const classes = useStyles(lessons && lessons.length >= 2);

  return (
    <div className={classes.card}>
      <div className={classes.titleRow}>
        <Typography style={{ fontWeight: 600 }} variant="body2">
          {lesson.title}
        </Typography>
      </div>
      {lesson.page?.pageNumber && (
        <span style={{ color: '#2878C1' }}>
          <FontAwesomeIcon size="1x" style={{ marginRight: 7, marginTop: 5 }} icon={faBookOpen} />
          p. {lesson.page.pageNumber}
        </span>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: any) => ({
  card: () => ({
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontWeight: 200,
    lineHeight: '24px'
  }),
  titleRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}));
